/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindIngestionsQueryResponse,
  FindIngestionsQueryParams,
} from "../types/FindIngestions.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findIngestionsQueryKey = (params: FindIngestionsQueryParams) =>
  [{ url: "/v1/ingestions" }, ...(params ? [params] : [])] as const

export type FindIngestionsQueryKey = ReturnType<typeof findIngestionsQueryKey>

/**
 * {@link /v1/ingestions}
 */
export async function findIngestions(
  params: FindIngestionsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindIngestionsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/ingestions`, params, ...requestConfig })
  return res
}

export function findIngestionsQueryOptions(
  params: FindIngestionsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findIngestionsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindIngestionsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindIngestionsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      return findIngestions(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * {@link /v1/ingestions}
 */
export function useFindIngestions<
  TData = ResponseConfig<FindIngestionsQueryResponse>,
  TQueryData = ResponseConfig<FindIngestionsQueryResponse>,
  TQueryKey extends QueryKey = FindIngestionsQueryKey,
>(
  params: FindIngestionsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindIngestionsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findIngestionsQueryKey(params)

  const query = useQuery(
    {
      ...findIngestionsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
